let SinglegameForcedStacking = {
    SINGLEGAME_FORCED_STACKING_IS_USED: 'SINGLEGAME_FORCED_STACKING_IS_USED',
    SINGLEGAME_FORCED_STACKING_SET_COMBO_IS_CHECKED: 'SINGLEGAME_FORCED_STACKING_SET_COMBO_IS_CHECKED',
    SINGLEGAME_FORCED_STACKING_SET_COMBO_EXPOSURE: 'SINGLEGAME_FORCED_STACKING_SET_COMBO_EXPOSURE',
};

export default SinglegameForcedStacking;
